import React, { useContext, useState } from "react";
import "./CareerPageStyle.css"; // Importing the new CSS
import { useTranslation } from "react-i18next";
import { careerAppService } from "../../backendServices/careerAppService";
import { Context } from "../LocalWrapper";
import Notify from "../Notify";

const CareerPage = ({ token }) => {
  const context = useContext(Context);
  const { t } = useTranslation();
  const initialState = {
    fullName: "",
    email: "",
    phone: "",
    coverLetter: "",
    cv: null,
  };
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Check file size (2 MB = 2 * 1024 * 1024 bytes)
    if (file && file.size > 2 * 1024 * 1024) {
      Notify(0, "File size exceeds 2 MB. Please upload a smaller file.");
      setFormData({ ...formData, cv: null }); // Reset the file input
      document.getElementById("cv").value = null; // Reset file input field
      return;
    }

    setFormData({
      ...formData,
      cv: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.fullName.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.cv
    ) {
      Notify(0, "Please fill out all required fields and upload your CV.");
      return;
    }

    // You can use fetch or axios to send data to the server
    try {
      const response = await careerAppService(token, { ...formData });
      if (response.status < 200 && response.status >= 300) {
        const errorData = await response.json();
        console.error("Error:", errorData.message);
        alert(errorData.message); // Display error to the user
        return;
      }

      setFormData(initialState);
      document.getElementById("cv").value = null; // Reset file input field
      Notify(1, response.data.message);

      // alert('Application submitted successfully!');
    } catch (error) {
      Notify(0, `${error.response.data.message}, Please try again.`);
      console.error("Error Applling!!:", error);
    }
  };

  return (
    <div className="career-page">
      <div className="header-container">
        <h2 className="oz-header">{t("career_title")}</h2>
        <p className="oz-paragraph">{t("career_paragraph")}</p>
      </div>
      <form
        onSubmit={handleSubmit}
        className="career-form"
        encType="multipart/form-data"
      >
        <div>
          <label htmlFor="fullName">* {t("full_name")}</label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="email">* {t("email")}</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="phone">* {t("phone")}</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label htmlFor="coverLetter">{t("cover_letter")}</label>
          <textarea
            id="coverLetter"
            name="coverLetter"
            rows="4"
            value={formData.coverLetter}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="file-upload">
          <label htmlFor="cv">* {t("upload_cv")}</label>
          <input
            type="file"
            id="cv"
            name="cv"
            accept="application/pdf"
            onChange={handleFileChange}
            required
          />
        </div>

        <button type="submit">{t("submit")}</button>
      </form>
    </div>
  );
};

export default CareerPage;
